import React, { useEffect, useState } from 'react';
import { Lightbulb } from 'lucide-react';
import { fetchFilterCounts } from '../services/api';
import { useApp } from '../context/AppContext';
import { FILTER_GROUPS, isGroupActive, filtersToParams } from '../hooks/useJobFilters';
import './FilterSuggestion.css';

const MIN_RESULTS = 5;

// filter-counts ignoriert den Branchen-Filter selbst: bei gewählten Branchen
// zählt deren Summe (wie im FilterDrawer)
const countOf = (data, branchen) => (branchen.length
  ? (data?.branchen || []).filter(b => branchen.includes(b.branche)).reduce((sum, b) => sum + b.count, 0)
  : data?.total ?? 0);

// Sicherheitsnetz: führen die selbst gesetzten Filter (Abweichung von den
// Vorbelegungen) zu weniger als 5 Treffern, wird der Filter vorgeschlagen,
// dessen Entfernen am meisten Treffer bringt.
// ponytail: eine filter-counts-Anfrage je aktivem Filter; bei sehr vielen
// Filtern gleichzeitig einen Sammel-Endpoint bauen
export default function FilterSuggestion({ filters, defaults, total, search, onChange }) {
  const { user } = useApp();
  const [hint, setHint] = useState(null);

  useEffect(() => {
    setHint(null);
    if (total == null || total >= MIN_RESULTS) return;
    const active = FILTER_GROUPS.filter(group => isGroupActive(group, filters, defaults));
    if (!active.length) return;

    let cancelled = false;
    Promise.all(active.map(group => {
      const without = { ...filters, ...Object.fromEntries(group.keys.map(k => [k, defaults[k]])) };
      return fetchFilterCounts({ ...filtersToParams(without, user), ...(search ? { search } : {}) })
        .then(({ data }) => ({ label: group.label, without, count: countOf(data, without.branchen) }))
        .catch(() => null);
    })).then(results => {
      if (cancelled) return;
      const best = results.filter(Boolean).sort((a, b) => b.count - a.count)[0];
      if (best && best.count > total) setHint(best);
    });
    return () => { cancelled = true; };
  }, [filters, defaults, total, search, user]);

  if (!hint) return null;
  return (
    <div className="filter-suggestion" role="status">
      <Lightbulb size={18} className="filter-suggestion__icon" />
      <p>
        {total === 0 ? 'Keine Treffer.' : `Nur ${total} Treffer.`}{' '}
        Ohne „{hint.label}“ wären es {hint.count}.
      </p>
      <button type="button" onClick={() => onChange(hint.without)}>
        „{hint.label}“ entfernen
      </button>
    </div>
  );
}
